(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MQ='(max-width:880px)';

  function init(root){
    if(root.dataset.eeBarInit) return;
    root.dataset.eeBarInit='1';

    var viewport=root.querySelector('.ee-bar__viewport');
    var track=root.querySelector('.ee-bar__track');
    var group=root.querySelector('.ee-bar__group');
    if(!viewport||!track||!group) return;

    var mq=window.matchMedia(MQ);
    var modeD=root.getAttribute('data-mode-desktop')||'fade';
    var modeM=root.getAttribute('data-mode-mobile')||modeD;
    var stickyD=root.getAttribute('data-sticky-d')==='1';
    var stickyM=root.getAttribute('data-sticky-m')==='1';
    var offsetOn=root.getAttribute('data-offset-header')==='1';
    var wrap=root.closest('.shopify-section')||root.parentElement;

    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer=null, paused=false, idx=0;

    function items(){ return group.querySelectorAll('.ee-bar__item'); }
    function show(i){
      var list=items(); if(!list.length) return;
      idx=((i%list.length)+list.length)%list.length;
      list.forEach(function(it,k){ it.classList.toggle('is-active',k===idx); });
    }

    // --- zanikanie ---
    function startFade(){
      stopMarquee();
      root.classList.add('ee-bar--fading');
      show(idx);
      clearInterval(timer); timer=null;
      if(items().length<2) return;
      var ms=Math.max(2,parseFloat(root.getAttribute('data-interval'))||4)*1000;
      timer=setInterval(function(){ if(!paused) show(idx+1); },ms);
    }
    function stopFade(){
      clearInterval(timer); timer=null;
      root.classList.remove('ee-bar--fading');
    }

    // --- przesuwanie ---
    function stopMarquee(){
      root.classList.remove('ee-bar--running');
      track.querySelectorAll('.ee-bar__group--clone').forEach(function(c){ c.remove(); });
    }
    function startMarquee(){
      stopFade();
      stopMarquee();
      var gw=group.scrollWidth;
      if(!gw) return;
      var need=viewport.clientWidth*2+gw, guard=0;
      while(track.scrollWidth<need && guard<20){
        var c=group.cloneNode(true);
        c.classList.add('ee-bar__group--clone');
        c.setAttribute('aria-hidden','true');
        c.querySelectorAll('a').forEach(function(a){ a.setAttribute('tabindex','-1'); });
        track.appendChild(c);
        guard++;
      }
      var speed=Math.max(10,parseFloat(root.getAttribute('data-speed'))||50);
      track.style.setProperty('--ee-bar-shift',(-gw)+'px');
      track.style.setProperty('--ee-bar-dur',(gw/speed)+'s');
      root.classList.add('ee-bar--running');
    }

    function currentMode(){ return mq.matches ? modeM : modeD; }
    function setModeClass(m){
      ['fade','marquee','static'].forEach(function(x){ root.classList.remove('ee-bar--'+x); });
      root.classList.add('ee-bar--'+m);
    }
    function fitsInRow(){ return group.scrollWidth<=viewport.clientWidth+2; }

    function layout(){
      var mode=currentMode();
      stopMarquee(); stopFade();
      setModeClass(mode);
      if(root.offsetParent===null){ return; } // pasek ukryty na tym urządzeniu
      if(mode==='marquee'){
        if(reduceMotion){ startFade(); } else { startMarquee(); }
      }else if(mode==='fade'){
        startFade();
      }else if(!fitsInRow()){
        startFade(); // static, ale się nie mieści
      }
    }

    // --- przyklejenie ---
    // Pasek sprawdza, co faktycznie zasłania górną krawędź ekranu (niezależnie od tego,
    // gdzie motyw ma menu w kodzie strony). Jeśli jest tam przyklejone/fixed menu,
    // pasek ustawia się tuż pod jego dolną krawędzią. Działa też dla menu, które
    // pojawia się dopiero przy przewijaniu i wysuwa się z animacją.
    function isStickyNow(){ return mq.matches ? stickyM : stickyD; }

    function topObstacle(){
      var best=0, z=null, seen=[];
      var w=window.innerWidth;
      [8, Math.round(w/2), w-8].forEach(function(x){
        var els=document.elementsFromPoint ? document.elementsFromPoint(x,1) : [];
        els.forEach(function(el){
          var c=el;
          while(c && c!==document.body && c!==document.documentElement){
            if(wrap.contains(c) || c.contains(wrap)) return;   // nasz pasek
            if(seen.indexOf(c)!==-1) return;
            var cs=getComputedStyle(c);
            if(cs.position==='fixed' || cs.position==='sticky'){
              seen.push(c);
              if(cs.display==='none' || cs.visibility==='hidden' || parseFloat(cs.opacity)===0) return;
              var r=c.getBoundingClientRect();
              if(!r.height || r.height>window.innerHeight*0.5) return; // szuflady, nakładki
              if(r.bottom<=0) return;                                  // schowane nad ekranem
              if(r.top>(parseFloat(cs.top)||0)+4) return;              // jeszcze nie przyklejone
              if(r.bottom>best){ best=r.bottom; z=cs.zIndex; }
              return;
            }
            c=c.parentElement;
          }
        });
      });
      return { bottom:Math.max(0,Math.round(best)), z:z };
    }

    // Niewidoczny znacznik tuż przed paskiem = naturalne miejsce paska na stronie.
    var sentinel=wrap.previousElementSibling;
    if(!sentinel || !sentinel.classList.contains('ee-bar-sentinel')){
      sentinel=document.createElement('div');
      sentinel.className='ee-bar-sentinel';
      sentinel.setAttribute('aria-hidden','true');
      sentinel.style.cssText='height:0;margin:0;padding:0;border:0';
      if(wrap.parentNode) wrap.parentNode.insertBefore(sentinel,wrap);
    }

    function unstick(){
      wrap.classList.remove('ee-bar-stuck');
      wrap.style.removeProperty('--ee-bar-top');
      wrap.style.removeProperty('--ee-bar-z');
      document.documentElement.style.setProperty('--ee-bar-sticky-h','0px');
    }

    function applySticky(){
      if(!isStickyNow() || root.offsetParent===null){ unstick(); return; }
      var info=offsetOn ? topObstacle() : { bottom:0, z:null };
      var target=info.bottom;
      // przyklejamy dopiero, gdy pasek dojechał do krawędzi (lub do dolnej krawędzi menu)
      var natural=sentinel.getBoundingClientRect().top;
      if(natural>target+0.5){ unstick(); return; }

      wrap.classList.add('ee-bar-stuck');
      var val=target+'px';
      if(wrap.style.getPropertyValue('--ee-bar-top')!==val) wrap.style.setProperty('--ee-bar-top',val);
      // pod menu: warstwa niżej niż menu, żeby rozwijane podmenu było nad paskiem
      var zi=parseInt(info.z,10);
      wrap.style.setProperty('--ee-bar-z', target>0 ? (isNaN(zi) ? '2' : String(Math.max(1,zi-1))) : '40');
      document.documentElement.style.setProperty('--ee-bar-sticky-h',(target+Math.round(wrap.getBoundingClientRect().height))+'px');
    }

    // Po każdym przewinięciu liczymy na bieżąco przez ~0,7 s (każda klatka),
    // żeby pasek płynnie podążał za wysuwającym się / chowającym menu.
    var loopUntil=0, looping=false;
    function kick(){
      loopUntil=Date.now()+700;
      if(looping) return;
      looping=true;
      (function step(){
        applySticky();
        if(Date.now()<loopUntil){ requestAnimationFrame(step); } else { looping=false; }
      })();
    }
    if(stickyD || stickyM){ window.addEventListener('scroll',kick,{passive:true}); }

    function relayout(){ layout(); kick(); }

    // pauza po najechaniu / fokusie
    function setPaused(v){ paused=v; root.classList.toggle('is-paused',v); }
    root.addEventListener('mouseenter',function(){ setPaused(true); });
    root.addEventListener('mouseleave',function(){ setPaused(false); });
    root.addEventListener('focusin',function(){ setPaused(true); });
    root.addEventListener('focusout',function(){ setPaused(false); });

    var rt;
    window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(relayout,200); });
    if(mq.addEventListener){ mq.addEventListener('change',relayout); } else if(mq.addListener){ mq.addListener(relayout); }

    // edytor motywu: zaznaczenie bloku pokazuje ten komunikat
    root.addEventListener('shopify:block:select',function(e){
      var list=Array.prototype.slice.call(items());
      var k=list.indexOf(e.target);
      setPaused(true);
      if(k!==-1 && root.classList.contains('ee-bar--fading')) show(k);
    });
    root.addEventListener('shopify:block:deselect',function(){ setPaused(false); });

    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(relayout); } else { relayout(); }
    setTimeout(kick,600); // motywy często inicjalizują sticky menu z opóźnieniem
  }

  function initAll(){ document.querySelectorAll('.ee-bar').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('ee-cd');
  if(!root) return;
  var overlay=document.getElementById('ee-cd-overlay');
  var panel=root.querySelector('.ee-cd__panel');
  var itemsEl=document.getElementById('ee-cd-items');
  var emptyEl=document.getElementById('ee-cd-empty');
  var footEl=document.getElementById('ee-cd-foot');
  var countEl=document.getElementById('ee-cd-count');
  var subtotalEl=document.getElementById('ee-cd-subtotal');
  var shipMsg=document.getElementById('ee-cd-ship-msg');
  var shipFill=document.getElementById('ee-cd-ship-fill');
  var errorEl=document.getElementById('ee-cd-error');
  var threshold=parseInt(root.getAttribute('data-threshold'),10)||0; // w jednostkach waluty (nie w groszach)
  var thresholdCents=threshold*100;
  var iconSelector=root.getAttribute('data-cart-icon-selector')||'';

  // --- adresy koszyka z Liquid (routes.*) — bezpieczne dla Markets / prefiksów językowych ---
  var URL_CART   =(root.getAttribute('data-url-cart')||'/cart')+'.js';
  var URL_ADD    =(root.getAttribute('data-url-add')||'/cart/add')+'.js';
  var URL_CHANGE =(root.getAttribute('data-url-change')||'/cart/change')+'.js';
  var MONEY_FORMAT=root.getAttribute('data-money-format')||'';
  var MSG_ERROR   =root.getAttribute('data-msg-error')||'Could not add item to cart.';
  var MSG_REACHED_NOTE=root.getAttribute('data-msg-reached-note')||'';
  // brak klucza w tłumaczeniach: Shopify zwraca "translation missing: ...", wtedy używamy tekstu zapasowego
  function i18n(attr,fallback){ var v=root.getAttribute(attr)||''; return (!v || v.indexOf('translation missing')===0)?fallback:v; }
  var MSG_BLOCKED=i18n('data-msg-blocked','Free shipping does not apply to this order');
  var MSG_BLOCKED_NOTE=i18n('data-msg-blocked-note','A product in your cart has higher shipping costs.');
  var SHIP_MAX=parseFloat(String(root.getAttribute('data-ship-max')||'0').replace(',','.'))||0;
  var shipMap={};   // product_id -> koszt dostawy (z metapola), odświeżane z HTML sekcji
  function readShipMap(scope){
    var el=(scope||document).querySelector('#ee-cd-shipmap');
    if(!el) return;
    try{ shipMap=JSON.parse(el.textContent||'{}')||{}; }catch(e){}
  }
  // Jeśli w koszyku jest choć jeden produkt, którego dostawa (metapole) jest droższa niż limit,
  // nie obiecujemy darmowej wysyłki ani nie pokazujemy licznika do progu. Taki produkt
  // (np. stolik) podnosi koszt dostawy całego zamówienia, także przy kilku sztukach.
  // Świadomy kompromis: produkt tuż nad limitem w dużym koszyku może w SST wyjść taniej,
  // wtedy klient w kasie zobaczy darmową wysyłkę mimo komunikatu. To bezpieczniejszy błąd
  // niż obiecanie darmowej wysyłki, której nie będzie.
  function shipBlocked(cart){
    if(!SHIP_MAX || !cart || !cart.items) return false;
    for(var i=0;i<cart.items.length;i++){
      var c=shipMap[String(cart.items[i].product_id)];
      if(typeof c==='number' && c>SHIP_MAX) return true;
    }
    return false;
  }
  var lastCart=null;
  readShipMap(document);

  // --- etykiety i18n (wszystkie konfigurowalne w ustawieniach sekcji) ---
  var LBL_REMOVE  =root.getAttribute('data-lbl-remove')||'Remove';
  var LBL_LESS    =root.getAttribute('data-lbl-less')||'Less';
  var LBL_MORE    =root.getAttribute('data-lbl-more')||'More';
  var LBL_FREESHIP=root.getAttribute('data-lbl-freeship')||'= free shipping';

  // --- format ceny wg shop.money_format (ten sam wynik co filtr `money` w Liquid) ---
  function money(cents){
    var f=MONEY_FORMAT;
    if(!f){
      var cur=root.getAttribute('data-currency')||'';
      return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})+' '+cur;
    }
    var re=/\{\{\s*(\w+)\s*\}\}/;
    function withDelims(number, precision, thousands, decimal){
      thousands=(thousands==null)?',':thousands;
      decimal=(decimal==null)?'.':decimal;
      precision=(precision==null)?2:precision;
      if(isNaN(number)||number==null) return '0';
      var n=(number/100).toFixed(precision).split('.');
      var main=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands);
      return main+(n[1]?decimal+n[1]:'');
    }
    var m=f.match(re);
    if(!m) return f;
    var v='';
    switch(m[1]){
      case 'amount':                                  v=withDelims(cents,2); break;
      case 'amount_no_decimals':                      v=withDelims(cents,0); break;
      case 'amount_with_comma_separator':             v=withDelims(cents,2,'.',','); break;
      case 'amount_no_decimals_with_comma_separator': v=withDelims(cents,0,'.',','); break;
      case 'amount_with_apostrophe_separator':        v=withDelims(cents,2,"'",'.'); break;
      case 'amount_with_space_separator':             v=withDelims(cents,2,' ',','); break;
      case 'amount_no_decimals_with_space_separator': v=withDelims(cents,0,' ',','); break;
      default:                                        v=withDelims(cents,2);
    }
    return f.replace(re,v);
  }

  // --- escapowanie treści wstawianej przez innerHTML (tytuły z & lub < ) ---
  function esc(s){
    return String(s==null?'':s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // --- komunikat błędu w panelu ---
  var errTimer=null;
  function showError(msg){
    if(!errorEl) return;
    errorEl.textContent=msg||MSG_ERROR;
    errorEl.removeAttribute('hidden');
    if(errTimer) clearTimeout(errTimer);
    errTimer=setTimeout(clearError, 8000);
  }
  function clearError(){ if(errorEl){ errorEl.setAttribute('hidden',''); errorEl.textContent=''; } }

  // --- wspólna konfiguracja dla innych sekcji (np. pasek darmowej wysyłki na stronie produktu) ---
  window.EE_CART_DRAWER={ thresholdCents:thresholdCents, moneyFormat:MONEY_FORMAT, open:function(){}, refresh:function(){} };

  // --- otwieranie / zamykanie ---
  var lastFocus=null;
  function open(){
    lastFocus=document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    var c=document.getElementById('ee-cd-close'); if(c) c.focus();
  }
  function close(){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
    clearError();
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  overlay.addEventListener('click',close);
  var closeBtn=document.getElementById('ee-cd-close');
  if(closeBtn) closeBtn.addEventListener('click',close);

  // --- klawiatura: Escape zamyka, Tab krąży wewnątrz panelu (aria-modal bez pułapki fokusu
  //     pozwalał wyjść tabulatorem na stronę pod spodem) ---
  var FOCUSABLE='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown',function(e){
    if(!root.classList.contains('is-open')) return;
    if(e.key==='Escape'){ close(); return; }
    if(e.key!=='Tab') return;
    var nodes=Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function(n){
      return n.offsetParent!==null || n===document.activeElement;
    });
    if(!nodes.length) return;
    var first=nodes[0], last=nodes[nodes.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    else if(!panel.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
  });

  // --- pobranie i render koszyka ---
  function getCart(){ return fetch(URL_CART,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  // --- SMART UPSELL: odświeżanie kart po zmianie koszyka ---
  // Liquid renderuje karty upsellu wg tego co jest w koszyku:
  //   → metapole upsell.recommended_ids (priorytet)
  //   → kolekcja fallback (gdy brak rekomendacji)
  // Po każdej zmianie koszyka JS pobiera świeży HTML sekcji przez Section Rendering API
  // i podmienia karty upsellu. Dzięki temu rekomendacje dostosowują się do zawartości koszyka.
  var SECTION_ID=root.getAttribute('data-section-id')||'ee-cart-drawer';
  var upsellContainer=document.getElementById('ee-cd-upsell');
  var upsellRefreshPending=false;
  var cartBusy=false;  // blokada równoległych zmian koszyka (zapobiega wyścigowi z nieświeżym kluczem linii)
  var upsellRefreshQueued=false;

  // Podmiana bloku upsellu na podstawie gotowego HTML sekcji.
  function applyUpsellHtml(html){
    if(!html) return;
    var tmp=document.createElement('div');
    tmp.innerHTML=html;
    var newUpsell=tmp.querySelector('#ee-cd-upsell');
    var oldUpsell=document.getElementById('ee-cd-upsell');
    if(newUpsell && oldUpsell){
      oldUpsell.innerHTML=newUpsell.innerHTML;
      oldUpsell.setAttribute('data-upsell-source', newUpsell.getAttribute('data-upsell-source')||'');
    }else if(newUpsell && !oldUpsell){
      var foot=document.getElementById('ee-cd-foot');
      if(foot) foot.parentElement.insertBefore(newUpsell.cloneNode(true), foot);
    }else if(!newUpsell && oldUpsell){
      oldUpsell.remove();
    }
    upsellTrack=document.getElementById('ee-cd-upsell-track');
    lastSortKey=null;
    initUpsellNav();
    readShipMap(tmp);
    renderShipAndUpsell(lastCart);
  }

  // Wyciąga HTML naszej sekcji z odpowiedzi Cart API (res.data.sections[...]).
  // Ten HTML jest GWARANTOWANIE spójny ze stanem koszyka po zmianie (ta sama operacja),
  // więc produkty w koszyku są poprawnie wykluczone z upsellu.
  function upsellHtmlFromCartResponse(data){
    if(data && data.sections && data.sections[SECTION_ID]){ return data.sections[SECTION_ID]; }
    return null;
  }

  // Fallback: osobne zapytanie do Section Rendering API (gdy nie mamy odpowiedzi Cart API,
  // np. przy otwarciu koszyka kliknięciem w ikonę). Cart API jest preferowane, bo jego
  // render jest spójny ze stanem koszyka; osobne zapytanie potrafi renderować sekcję
  // ze stanem koszyka opóźnionym o ułamek sekundy.
  function refreshUpsell(){
    if(upsellRefreshPending){ upsellRefreshQueued=true; return; }
    upsellRefreshPending=true;
    var basePath=window.location.pathname;
    var sep=(basePath.indexOf('?')!==-1?'&':'?');
    var url=basePath+sep+'sections='+SECTION_ID+'&_='+Date.now();
    fetch(url,{headers:{'Accept':'application/json'},cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(data){ applyUpsellHtml(data[SECTION_ID]); })
      .catch(function(){})
      .then(function(){
        upsellRefreshPending=false;
        if(upsellRefreshQueued){ upsellRefreshQueued=false; refreshUpsell(); }
      });
  }

  // upsell: sortowanie kart wg brakującej kwoty do progu (remaining w groszach)
  //
  // ZASADA: manual i AI to CELOWANE rekomendacje — ich sens to trafność, nie dobicie
  // do progu. Zostają więc ZAWSZE w kolejności ustalonej w Liquid (interleave faz).
  // Sortowaniu "ile brakuje do darmowej wysyłki" podlega TYLKO faza collection
  // (fallback z kolekcji upsell), bo to produkty ogólne, które równie dobrze mogą
  // pełnić rolę "dobierz do progu".
  //
  // Efekt: [manual w kolejności][AI w kolejności][kolekcja posortowana pod próg]
  var upsellTrack=document.getElementById('ee-cd-upsell-track');
  var lastSortKey=null;
  function sortUpsell(remaining){
    if(!upsellTrack) return;
    var cards=Array.prototype.slice.call(upsellTrack.querySelectorAll('.ee-cd__up'));
    if(!cards.length) return;
    // przelicz tylko gdy realnie zmienia się kwota do progu (albo brak progu)
    var key=(!remaining||remaining<=0)?'none':String(remaining);
    if(key===lastSortKey) return;
    lastSortKey=key;

    // rozdziel karty na priorytetowe (manual+AI) i kolekcję
    var priority=[]; // manual + ai — kolejność z Liquid nienaruszona
    var collection=[];
    cards.forEach(function(c){
      var phase=c.getAttribute('data-upsell-phase');
      if(phase==='collection'){ collection.push(c); }
      else { priority.push(c); }
    });

    // priorytetowe: przywróć oryginalną kolejność z Liquid (data-index rosnąco)
    priority.sort(function(a,b){ return (+a.getAttribute('data-index'))-(+b.getAttribute('data-index')); });

    // kolekcja: pod próg (jeśli jest), inaczej oryginalna kolejność
    if(!remaining || remaining<=0){
      collection.sort(function(a,b){ return (+a.getAttribute('data-index'))-(+b.getAttribute('data-index')); });
    }else{
      collection.sort(function(a,b){
        var pa=+a.getAttribute('data-price'), pb=+b.getAttribute('data-price');
        var aHits=pa>=remaining, bHits=pb>=remaining;
        if(aHits && bHits) return pa-pb;      // oba dobijają → tańszy z dobijających pierwszy
        if(aHits) return -1;                  // dobijający przed niedobijającym
        if(bHits) return 1;
        return pb-pa;                          // żaden nie dobija → droższy pierwszy (bliżej progu)
      });
    }

    // złóż z powrotem: najpierw manual+AI, potem kolekcja
    priority.concat(collection).forEach(function(c){ upsellTrack.appendChild(c); });
    upsellTrack.scrollLeft=0;
  }

  function render(cart){
    lastCart=cart;
    // licznik
    countEl.textContent=cart.item_count;
    renderShipAndUpsell(cart);
    renderItems(cart);
  }

  // pasek darmowej dostawy + sortowanie i badge upsellu
  // (wywoływane też po podmianie HTML sekcji, bo wtedy przychodzi świeża mapa kosztów dostawy i nowe karty)
  function renderShipAndUpsell(cart){
    if(!cart) return;
    var blocked=shipBlocked(cart);
    var shipBox=document.getElementById('ee-cd-ship');
    // Produkt z drogą dostawą w koszyku:
    //  - poniżej progu: chowamy pasek całkiem (nie obiecujemy licznikiem i nie straszymy komunikatem,
    //    darmowa wysyłka i tak jeszcze nie przysługuje),
    //  - od progu: pokazujemy, że darmowa wysyłka nie przysługuje (żeby nie było rozczarowania w kasie).
    var hideShip=blocked && cart.item_count>0 && thresholdCents>0 && cart.total_price<thresholdCents;
    if(shipBox){
      shipBox.classList.toggle('is-blocked', blocked && cart.item_count>0 && !hideShip);
      shipBox.classList.toggle('is-hidden', hideShip);
    }
    // pasek dostawy
    if(shipMsg && shipFill && thresholdCents>0){
      var total=cart.total_price;
      var pct=Math.min(100, Math.round(total/thresholdCents*100));
      shipFill.style.width=pct+'%';
      shipMsg.classList.remove('is-blocked');
      if(blocked && cart.item_count>0){
        // produkt z droższą dostawą: darmowa wysyłka nie przysługuje niezależnie od kwoty
        shipMsg.innerHTML=esc(MSG_BLOCKED)+(MSG_BLOCKED_NOTE?'<span class="ee-cd__ship-note">'+esc(MSG_BLOCKED_NOTE)+'</span>':'');
        shipMsg.classList.remove('is-reached'); shipFill.classList.remove('is-reached');
        shipMsg.classList.add('is-blocked');
      }else if(total>=thresholdCents){
        var reached=root.getAttribute('data-msg-reached')||'Free shipping!';
        var note=MSG_REACHED_NOTE?'<span class="ee-cd__ship-note">'+esc(MSG_REACHED_NOTE)+'</span>':'';
        shipMsg.innerHTML='✓ '+esc(reached)+note;
        shipMsg.classList.add('is-reached'); shipFill.classList.add('is-reached');
      }else{
        var left=money(thresholdCents-total);
        var tmpl=root.getAttribute('data-msg-progress')||'Free shipping in %amount%';
        shipMsg.innerHTML=tmpl.replace('%amount%','<b>'+left+'</b>');
        shipMsg.classList.remove('is-reached'); shipFill.classList.remove('is-reached');
      }
    }
    // upsell: posortuj wg brakującej kwoty do progu (przy blokadzie dobijanie do progu nic nie daje)
    var remaining=(thresholdCents>0 && !blocked) ? Math.max(0, thresholdCents - cart.total_price) : 0;
    sortUpsell(remaining);

    // upsell: badge darmowej wysyłki — zielona ikonka ciężarówki w rogu zdjęcia,
    // tooltip z pełnym tekstem na hover. Pusty label w ustawieniach = wyłączona funkcja.
    // UWAGA: badge pojawia się TYLKO na kartach fazy 'collection' — manual i AI są
    // celowanymi rekomendacjami oderwanymi od progu darmowej wysyłki (zgodnie z logiką
    // sortowania: tylko kolekcja pełni rolę "dobierz do progu").
    if(upsellTrack && LBL_FREESHIP){
      var cartIds={};
      cart.items.forEach(function(it){ cartIds[String(it.variant_id)]=true; });
      var SHIP_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 17H1V7h12v10m0 0h6V12l-3-3h-3M8 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"/></svg>';
      var upCards=upsellTrack.querySelectorAll('.ee-cd__up');
      upCards.forEach(function(card){
        var existing=card.querySelector('.ee-cd__up-ship');
        var addBtn=card.querySelector('.ee-cd__up-add');
        var inCart=addBtn && cartIds[addBtn.getAttribute('data-variant-id')];
        var isCollection=card.getAttribute('data-upsell-phase')==='collection';
        if(isCollection && !inCart && remaining>0 && (+card.getAttribute('data-price'))>=remaining){
          if(!existing){
            var badge=document.createElement('div');
            badge.className='ee-cd__up-ship';
            badge.setAttribute('data-tip',LBL_FREESHIP);
            badge.innerHTML=SHIP_SVG;
            // wstaw na początek karty (nakłada się na lewy górny róg zdjęcia)
            card.insertBefore(badge, card.firstChild);
          }
        }else{
          if(existing) existing.remove();
        }
      });
    }
  }

  function renderItems(cart){
    // pozycje
    if(cart.item_count===0){
      itemsEl.innerHTML='';
      emptyEl.hidden=false;
      footEl.hidden=true;
      return;
    }
    emptyEl.hidden=true;
    footEl.hidden=false;
    subtotalEl.innerHTML=money(cart.total_price);
    var html='';
    cart.items.forEach(function(it){
      var was='';
      if(it.original_line_price>it.final_line_price){
        was='<span class="ee-cd__was">'+money(it.original_line_price)+'</span>';
      }
      var variant=(it.variant_title && it.variant_title!=='Default Title')?('<div class="ee-cd__item-variant">'+esc(it.variant_title)+'</div>'):'';
      var img=it.image?('<img src="'+esc(it.image.replace(/(\.[^./]+)(\?|$)/,'_120x120$1$2'))+'" alt="" loading="lazy">'):'';
      var itemUrl=it.url?esc(it.url):'';
      var nameHtml=itemUrl
        ? '<a class="ee-cd__item-name ee-cd__item-name--link" href="'+itemUrl+'" data-ee-no-drawer>'+esc(it.product_title)+'</a>'
        : '<p class="ee-cd__item-name">'+esc(it.product_title)+'</p>';
      html+=''
        +'<li class="ee-cd__item" data-key="'+esc(it.key)+'">'
        +'  <div class="ee-cd__item-img">'+img+'</div>'
        +'  <div class="ee-cd__item-mid">'
        +     nameHtml
        +     variant
        +'    <div class="ee-cd__qty">'
        +'      <button type="button" data-act="dec" aria-label="'+esc(LBL_LESS)+'">−</button>'
        +'      <span>'+it.quantity+'</span>'
        +'      <button type="button" data-act="inc" aria-label="'+esc(LBL_MORE)+'">+</button>'
        +'    </div>'
        +'  </div>'
        +'  <div class="ee-cd__item-right">'
        +'    <div class="ee-cd__item-price">'+money(it.final_line_price)+was+'</div>'
        +'    <button type="button" class="ee-cd__remove" data-act="remove">'+esc(LBL_REMOVE)+'</button>'
        +'  </div>'
        +'</li>';
    });
    itemsEl.innerHTML=html;
  }

  function refresh(){ return getCart().then(function(cart){ render(cart); refreshUpsell(); return cart; }); }

  // --- zmiana ilości / usuwanie (Cart Change API) ---
  // zwraca {ok:bool, data:obiekt} — bez tego błędy 422 z Shopify wyglądały jak sukces
  function readJson(r){
    return r.json().catch(function(){ return {}; }).then(function(d){ return {ok:r.ok, data:d}; });
  }
  function errText(d){
    return (d && (d.description || d.message)) || MSG_ERROR;
  }

  function changeLine(key, quantity){
    // blokada równoległych operacji — bez niej szybkie klikanie wysyłało zmianę ze
    // starym (nieświeżym) kluczem linii, na co Shopify odpowiada 422
    // "inget giltigt id / no valid id". Dopóki jedna zmiana trwa, kolejne są ignorowane.
    if(cartBusy) return;
    cartBusy=true;
    // oznacz TYLKO edytowaną pozycję jako busy (puls) — reszta koszyka działa normalnie
    var li=itemsEl.querySelector('.ee-cd__item[data-key="'+key+'"]');
    if(li) li.classList.add('is-busy');
    clearError();
    return fetch(URL_CHANGE,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      // sections: prosimy Shopify, żeby w TEJ SAMEJ odpowiedzi zwrócił odświeżony HTML
      // sekcji — spójny z nowym stanem koszyka. Dzięki temu produkty w koszyku są
      // poprawnie wykluczone z upsellu (koniec z produktem, który jest i w koszyku, i w upsellu).
      body:JSON.stringify({id:key,quantity:quantity,sections:SECTION_ID,sections_url:window.location.pathname})
    }).then(readJson).then(function(res){
      if(!res.ok){
        // Nieświeży klucz linii (422) to nie błąd dla klienta — to rozjechany stan.
        // Zamiast czerwonego komunikatu po prostu cicho przeładuj realny koszyk.
        return refresh();
      }
      render(res.data);
      var html=upsellHtmlFromCartResponse(res.data);
      if(html){ applyUpsellHtml(html); }   // spójny render z Cart API
      else { refreshUpsell(); }             // fallback, gdyby sekcji nie było w odpowiedzi
      syncHeaderCount(res.data.item_count);
    }).catch(function(){
      // gdyby fetch się nie udał — zdejmij busy i przeładuj koszyk (bez straszenia błędem)
      if(li) li.classList.remove('is-busy');
      return refresh();
    }).then(function(){
      cartBusy=false;   // zwolnij blokadę niezależnie od wyniku
    });
  }

  itemsEl.addEventListener('click',function(e){
    var btn=e.target.closest('button'); if(!btn) return;
    var li=e.target.closest('.ee-cd__item'); if(!li) return;
    var key=li.getAttribute('data-key');
    var act=btn.getAttribute('data-act');
    var qtySpan=li.querySelector('.ee-cd__qty span');
    var cur=parseInt(qtySpan.textContent,10)||1;
    if(act==='inc') changeLine(key,cur+1);
    else if(act==='dec') changeLine(key,Math.max(0,cur-1));
    else if(act==='remove') changeLine(key,0);
  });

  // --- dodawanie (przechwytywanie /cart/add) ---
  var _addingBtn=null;
  function addVariant(id, qty, triggerBtn, properties){
    cartBusy=true;   // na czas dodawania zablokuj zmiany ilości/usuwanie (klucze linii się zmieniają)
    if(_addingBtn) _addingBtn.disabled=false;
    _addingBtn=triggerBtn||null;
    if(_addingBtn) _addingBtn.disabled=true;
    clearError();
    var item={id:id,quantity:qty||1};
    if(properties) item.properties=properties;
    return fetch(URL_ADD,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[item],sections:SECTION_ID,sections_url:window.location.pathname})
    }).then(readJson).then(function(res){
      // pobierz świeży koszyk (do listy pozycji, paska, licznika)
      return getCart().then(function(cart){
        render(cart);
        // upsell: preferuj spójny HTML z odpowiedzi /cart/add (zawiera już nowy produkt,
        // więc jest on wykluczony z rekomendacji); fallback na osobne zapytanie
        var html=upsellHtmlFromCartResponse(res.data);
        if(html){ applyUpsellHtml(html); } else { refreshUpsell(); }
        if(_addingBtn){ _addingBtn.disabled=false; _addingBtn=null; }
        open();
        if(!res.ok) showError(errText(res.data));
        if(cart) syncHeaderCount(cart.item_count);
        return cart;
      });
    }).catch(function(){
      if(_addingBtn){ _addingBtn.disabled=false; _addingBtn=null; }
      open();
      showError(MSG_ERROR);
    }).then(function(){
      cartBusy=false;   // zwolnij blokadę po zakończeniu dodawania (sukces lub błąd)
    });
  }

  // upsell "dodaj" — dwie warstwy śledzenia:
  //   1) line item property (_upsell_source) → źródło (manual/ai/collection) widoczne
  //      przy pozycji w zamówieniu. Właściwość jest przyklejona do POZYCJI, więc gdy
  //      klient usunie produkt, znika razem z nim — w zamówieniu nie zostaje "duch".
  //   2) dataLayer event (add_to_cart) → GA4 pokazuje dodania BEZ zamówienia
  root.addEventListener('click',function(e){
    var up=e.target.closest('.ee-cd__up-add'); if(!up) return;
    var id=up.getAttribute('data-variant-id'); if(!id) return;
    var card=up.closest('.ee-cd__up');
    var name=card?(card.querySelector('.ee-cd__up-name')||{}).textContent||'':'';
    var priceCents=card?+(card.getAttribute('data-price')||0):0;
    var cur=root.getAttribute('data-currency')||'PLN';
    // faza karty: manual / ai / collection (ustawiona w Liquid jako data-upsell-phase)
    var phase=card?(card.getAttribute('data-upsell-phase')||'collection'):'collection';

    // --- GA4 / GTM dataLayer: event PRZED fetchem, żeby złapać nawet porzucone koszyki ---
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({ecommerce:null}); // wyczyść poprzedni obiekt e-commerce
      window.dataLayer.push({
        event:'add_to_cart',
        ecommerce:{
          currency:cur,
          value:priceCents/100,
          items:[{
            item_id:String(id),
            item_name:name.trim(),
            item_list_name:'cart_upsell',
            item_variant:phase,   // źródło upsellu w GA4
            price:priceCents/100,
            quantity:1
          }]
        }
      });
    }catch(e){}

    // line item property — źródło upsellu (manual/ai/collection) na tej konkretnej pozycji
    addVariant(id, 1, up, {
      _upsell_source: phase
    });
  });

  // przechwyć wszystkie formularze dodawania do koszyka na stronie
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form || form.getAttribute('action')===null) return;
    if(form.hasAttribute('data-ee-no-drawer')) return;
    // Dynamiczne przyciski płatności (PayPal Express, Google Pay, Shop Pay, Apple Pay) —
    // mają własną logikę SDK dostawcy płatności. Przechwycenie ich submitu przez nasz
    // fetch zepsułoby cały przepływ (np. otwarcie natywnego arkusza płatności).
    if(e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    var action=form.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // zablokuj handler motywu — bez tego motyw otworzy swój drawer/page
    var fd=new FormData(form);
    // poproś o odświeżony HTML sekcji spójny z nowym stanem koszyka
    fd.append('sections', SECTION_ID);
    fd.append('sections_url', window.location.pathname);
    var submitBtn=e.submitter || form.querySelector('[type="submit"]');
    if(submitBtn) submitBtn.disabled=true;
    clearError();
    fetch(URL_ADD,{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(readJson)
      .then(function(res){
        return getCart().then(function(cart){
          render(cart);
          var html=upsellHtmlFromCartResponse(res.data);
          if(html){ applyUpsellHtml(html); } else { refreshUpsell(); }
          if(submitBtn) submitBtn.disabled=false;
          open();
          if(!res.ok) showError(errText(res.data));
          if(cart) syncHeaderCount(cart.item_count);
        });
      })
      .catch(function(){ if(submitBtn) submitBtn.disabled=false; form.submit(); });
  },true);

  // --- przechwyć klik w ikonę koszyka w nagłówku ---
  // selektor konfigurowalny + rozsądne domyślne dla popularnych motywów
  var defaultIconSelectors=[
    'a[href="/cart"]','a[href$="/cart"]',
    '.cart-link','.header__icon--cart','.site-header__cart',
    '#cart-icon-bubble','[data-cart-icon]','.js-drawer-open-cart'
  ];
  var selectors=defaultIconSelectors.slice();
  if(iconSelector){ selectors=iconSelector.split(',').map(function(s){return s.trim();}).concat(selectors); }
  document.addEventListener('click',function(e){
    // element (lub jego rodzic) z data-ee-no-drawer ma działać normalnie —
    // np. link "więcej metod płatności" na stronie produktu prowadzi do STRONY koszyka
    if(e.target.closest && e.target.closest('[data-ee-no-drawer]')) return;
    for(var i=0;i<selectors.length;i++){
      var el=e.target.closest(selectors[i]);
      if(el){
        e.preventDefault();
        e.stopImmediatePropagation(); // zablokuj handler motywu
        open(); refresh(); return;
      }
    }
  },true);

  // --- synchronizacja licznika w nagłówku (best-effort) ---
  function syncHeaderCount(count){
    var nodes=document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count],#cart-icon-bubble .cart-count-bubble span');
    nodes.forEach(function(n){ n.textContent=count; });
  }

  // --- popup warunków darmowej wysyłki ---
  var shipInfoBtn=document.getElementById('ee-cd-ship-info-btn');
  var shipPopup=document.getElementById('ee-cd-ship-popup');
  var shipPopupClose=document.getElementById('ee-cd-ship-popup-close');
  if(shipInfoBtn && shipPopup){
    shipInfoBtn.addEventListener('click',function(){
      var open=!shipPopup.hasAttribute('hidden');
      if(open){ shipPopup.setAttribute('hidden',''); }
      else{ shipPopup.removeAttribute('hidden'); }
    });
    if(shipPopupClose) shipPopupClose.addEventListener('click',function(){ shipPopup.setAttribute('hidden',''); });
  }

  // upsell: zwijanie sekcji + nawigacja — wyodrębnione do funkcji,
  // bo po refreshUpsell() karty są podmieniane i eventy trzeba podpiąć ponownie
  function initUpsellNav(){
    var upsellBox=document.getElementById('ee-cd-upsell');
    var toggle=document.getElementById('ee-cd-upsell-toggle');
    if(upsellBox && toggle){
      // usuwamy stare listenery przez klonowanie elementu
      var newToggle=toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);
      newToggle.addEventListener('click',function(){
        var collapsed=upsellBox.classList.toggle('is-collapsed');
        newToggle.setAttribute('aria-expanded',String(!collapsed));
      });
    }

    var track=document.getElementById('ee-cd-upsell-track');
    var prev=document.getElementById('ee-cd-up-prev');
    var next=document.getElementById('ee-cd-up-next');
    if(track && prev && next){
      var newPrev=prev.cloneNode(true); prev.parentNode.replaceChild(newPrev, prev);
      var newNext=next.cloneNode(true); next.parentNode.replaceChild(newNext, next);
      var stepBy=function(){ return Math.max(120, track.clientWidth*0.7); };
      newPrev.addEventListener('click',function(){ track.scrollBy({left:-stepBy(),behavior:'smooth'}); });
      newNext.addEventListener('click',function(){ track.scrollBy({left:stepBy(),behavior:'smooth'}); });
      var updateNav=function(){
        var max=track.scrollWidth-track.clientWidth-2;
        newPrev.disabled=track.scrollLeft<=2;
        newNext.disabled=track.scrollLeft>=max;
      };
      track.addEventListener('scroll',updateNav,{passive:true});
      setTimeout(updateNav,50);
    }
  }
  initUpsellNav();

  // start
  window.EE_CART_DRAWER.open=function(){ open(); refresh(); };
  window.EE_CART_DRAWER.refresh=refresh;
  document.dispatchEvent(new CustomEvent('ee:cart-drawer-ready'));
  refresh();

  // --- CHECKOUT ---
  // Formularz "Do kasy" jest samowystarczalny: action=routes.cart_url, method=post,
  // ukryte pole name="checkout" → Shopify sam przekierowuje prosto do kasy przy zwykłym
  // submitcie. Nie przechwytujemy go JS-em: źródło upsellu zapisujemy jako line item
  // property (_upsell_source) już przy dodaniu, więc nie ma nic do ustawiania przy checkoucie.
  // (Wcześniejsze ustawianie atrybutów koszyka _has_upsell było źródłem "duchów" w zamówieniach
  //  i zostało usunięte — property na pozycji znika automatycznie, gdy klient usunie produkt.)

  // --- WYŁĄCZENIE WBUDOWANEGO DRAWERA MOTYWU ---
  // MutationObserver: gdy motyw dynamicznie otwiera swój drawer (zmiana class/style/open),
  // natychmiast go chowamy. Działa na Dawn, Debut, Sense, Craft i większość motywów.
  (function(){
    var THEME_SEL=[
      'cart-drawer','cart-notification','.cart-drawer','#CartDrawer',
      '.mini-cart','[data-cart-drawer]','#cart-drawer','.drawer--cart',
      '.quick-cart','[id*="cart-drawer"]:not(#ee-cd)',
      '[class*="cart-drawer"]:not(.ee-cd-root)'
    ];
    function kill(){
      THEME_SEL.forEach(function(s){
        try{
          document.querySelectorAll(s).forEach(function(el){
            if(el===root||root.contains(el)||el.contains(root)) return;
            el.style.setProperty('display','none','important');
            el.setAttribute('aria-hidden','true');
            try{el.close&&el.close();}catch(x){}
            try{el.open=function(){};el.show=function(){};}catch(x){}
          });
        }catch(e){}
      });
    }
    kill();
    try{
      new MutationObserver(kill).observe(document.body,
        {childList:true,subtree:true,attributes:true,attributeFilter:['class','style','open']});
    }catch(e){}
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-promo-timer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function parts(date, tz){
    var o = {};
    new Intl.DateTimeFormat('en-US',{timeZone:tz,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false})
      .formatToParts(date).forEach(function(p){ o[p.type] = p.value; });
    return {y:+o.year, mo:+o.month, d:+o.day, h:(o.hour === '24' ? 0 : +o.hour), mi:+o.minute, s:+o.second};
  }
  function offset(date, tz){
    var p = parts(date, tz);
    return Date.UTC(p.y, p.mo-1, p.d, p.h, p.mi, p.s) - (date.getTime() - date.getTime() % 1000);
  }
  // "DD.MM.RRRR GG:MM" (lub "RRRR-MM-DD GG:MM") w strefie tz -> timestamp
  function parseWall(s, tz){
    s = String(s || '').trim();
    if(!s) return null;
    var m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T,]+(\d{1,2})[:.](\d{2}))?$/), y, mo, d, h, mi;
    if(m){ d = +m[1]; mo = +m[2]; y = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0; }
    else{
      m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?$/);
      if(!m) return null;
      y = +m[1]; mo = +m[2]; d = +m[3]; h = m[4] ? +m[4] : 0; mi = m[5] ? +m[5] : 0;
    }
    var guess = Date.UTC(y, mo-1, d, h, mi, 0);
    var ts = guess - offset(new Date(guess), tz);
    return guess - offset(new Date(ts), tz);
  }
  var pad = function(n){ return String(n).padStart(2, '0'); };

  function init(root){
    if(!root || root.getAttribute('data-ept-ready')) return;
    root.setAttribute('data-ept-ready', '1');
    var tz = root.getAttribute('data-tz') || 'Europe/Warsaw';
    try{ new Intl.DateTimeFormat('en-US',{timeZone:tz}); }catch(e){ tz = 'Europe/Warsaw'; }
    var start = parseWall(root.getAttribute('data-start'), tz);
    var end = parseWall(root.getAttribute('data-end'), tz);
    var p2 = parseWall(root.getAttribute('data-p2-from'), tz);
    var before = root.getAttribute('data-before') || 'countdown';
    var lblEnds = root.getAttribute('data-lbl-ends') || '';
    var lblStarts = root.getAttribute('data-lbl-starts') || lblEnds;
    var lblEl = root.querySelector('.ept__lbl');
    var u = {d:root.querySelector('[data-u="d"]'), h:root.querySelector('[data-u="h"]'), m:root.querySelector('[data-u="m"]'), s:root.querySelector('[data-u="s"]')};
    var p1Els = root.querySelectorAll('[data-p1]'), p2Els = root.querySelectorAll('[data-p2]');
    if(!end){ if(window.console) console.warn('[EE timer] Zly format daty konca (DD.MM.RRRR GG:MM).'); return; }

    var timer = null, lastPhase = null;
    function setPhase(two){
      if(two === lastPhase) return;
      lastPhase = two;
      p1Els.forEach(function(e){ if(two) e.setAttribute('hidden',''); else e.removeAttribute('hidden'); });
      p2Els.forEach(function(e){ if(two) e.removeAttribute('hidden'); else e.setAttribute('hidden',''); });
    }
    function tick(){
      if(!document.body.contains(root)){ clearInterval(timer); return; }
      var t = Date.now(), target, label;
      if(start && t < start){
        if(before !== 'countdown'){ root.setAttribute('hidden',''); return; }
        target = start; label = lblStarts;
      }else if(t < end){
        target = end; label = lblEnds;
      }else{
        root.setAttribute('hidden','');
        clearInterval(timer);
        return;
      }
      setPhase(!!(p2 && t >= p2 && t < end));
      if(lblEl && lblEl.textContent !== label) lblEl.textContent = label;
      var diff = target - t;
      u.d.textContent = pad(Math.floor(diff/86400000));
      u.h.textContent = pad(Math.floor(diff%86400000/3600000));
      u.m.textContent = pad(Math.floor(diff%3600000/60000));
      u.s.textContent = pad(Math.floor(diff%60000/1000));
      root.removeAttribute('hidden');
    }
    timer = setInterval(tick, 1000);
    tick();
  }
  function initAll(){ document.querySelectorAll('.ept').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // edytor motywu: sekcja przeładowana po zmianie ustawień
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('.ept')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='ee_recently_viewed';
  var MAXSTORE=20;

  function read(){
    try{ var v=JSON.parse(window.localStorage.getItem(KEY)||'[]'); return Array.isArray(v)?v:[]; }
    catch(e){ return []; }
  }
  function write(list){
    try{ window.localStorage.setItem(KEY, JSON.stringify(list.slice(0,MAXSTORE))); }catch(e){}
  }

  var sections=document.querySelectorAll('.ee-rv');
  sections.forEach(function(root){
    if(root.dataset.eeRvInit) return;
    root.dataset.eeRvInit='1';

    // Zabezpieczenie: na stronie bywa pusty blok (typowo <div class="rte">), do którego
    // Shopify/motyw wstawia komunikat "This section doesn't currently include any content".
    // Ten blok jest POZA naszą sekcją (to inna, pusta sekcja motywu), więc szukamy globalnie.
    // Ukrywamy TYLKO element, którego cała treść to ten komunikat (zero ryzyka dla realnej treści).
    (function(){
      var MSG1="doesn't currently include any content";
      var MSG1b="doesn’t currently include any content"; // wariant z typograficznym apostrofem
      var MSG2="add content to this section";
      var candidates=document.querySelectorAll('.rte, .shopify-section-placeholder, [data-section-placeholder]');
      candidates.forEach(function(el){
        var t=(el.textContent||'').trim().toLowerCase();
        if(t && (t.indexOf(MSG1)!==-1 || t.indexOf(MSG1b)!==-1 || t.indexOf(MSG2)!==-1)){
          // ukryj sam element; jeśli to jedyna treść jego sekcji, ukryj też wrapper sekcji
          el.style.display='none';
          var sec=el.closest('.shopify-section');
          if(sec && (sec.textContent||'').trim().toLowerCase().indexOf(MSG1)!==-1){
            // wrapper zawiera tylko ten komunikat → schowaj całą pustą sekcję
            if((sec.textContent||'').trim().length < 120) sec.style.display='none';
          }
        }
      });
    })();

    var currentHandle=root.getAttribute('data-current-handle')||'';
    var max=parseInt(root.getAttribute('data-max'),10)||5;
    var addLabel=root.getAttribute('data-add-label')||'Add to cart';
    var heading=root.getAttribute('data-heading')||'Recently viewed';
    var prevLabel=root.getAttribute('data-prev-label')||'Previous';
    var nextLabel=root.getAttribute('data-next-label')||'Next';
    var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';
    var track=null; // powstanie dopiero w renderCards

    // 1) zapisz bieżący produkt na początek listy (bez duplikatu)
    if(currentHandle){
      var list=read().filter(function(h){ return h!==currentHandle; });
      list.unshift(currentHandle);
      write(list);
    }

    // 2) zbuduj listę do pokazania: wszystko z localStorage oprócz bieżącego
    var toShow=read().filter(function(h){ return h!==currentHandle; }).slice(0,max);
    if(!toShow.length){ return; } // pusto → sekcja zostaje hidden

    // 3) pobierz dane produktów i wyrenderuj karty (kolejność zachowana)
    var results=new Array(toShow.length);
    var pending=toShow.length;
    toShow.forEach(function(handle,idx){
      fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(p){ results[idx]=p; })
        .catch(function(){ results[idx]=null; })
        .then(function(){
          pending-=1;
          if(pending===0) renderCards(results);
        });
    });

    function money(cents){
      // preferuj globalny formatter ze strony produktu, jak jest
      if(typeof window.eeFormatMoney==='function'){ return window.eeFormatMoney(cents); }
      return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
    }
    function esc(s){
      return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function renderCards(products){
      var cards='';
      products.forEach(function(p){
        if(!p || !p.available) return; // pomiń niedostępne / niepobrane
        var variantId=(p.variants&&p.variants[0])?p.variants[0].id:'';
        if(!variantId) return;
        var img=p.featured_image?('<img src="'+esc(p.featured_image)+'" alt="" loading="lazy">'):'';
        cards+=''
          +'<div class="ee-rec__card" data-rec-phase="recent" data-price="'+(p.price||0)+'">'
          +'  <a class="ee-rec__img" href="'+esc(p.url)+'">'+img
          +'    <span class="ee-rec__view" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg></span>'
          +'  </a>'
          +'  <a class="ee-rec__name" href="'+esc(p.url)+'">'+esc(p.title)+'</a>'
          +'  <div class="ee-rec__price">'+money(p.price)+'</div>'
          +'  <button type="button" class="ee-rec__add" data-variant-id="'+esc(variantId)+'">'+esc(addLabel)+'</button>'
          +'</div>';
      });
      if(!cards){ return; } // wszystkie niedostępne → sekcja zostaje ukryta, nic nie wstawiamy

      // Zbuduj CAŁĄ strukturę dopiero teraz (nagłówek, strzałki, track) — wcześniej
      // sekcja była pusta, więc przy braku historii nic się nie pokazywało.
      var prevSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m15 18-6-6 6-6"/></svg>';
      var nextSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m9 6 6 6-6 6"/></svg>';
      root.innerHTML=''
        +'<div class="ee-rec__head">'
        +'  <h2 class="ee-rec__title">'+esc(heading)+'</h2>'
        +'  <div class="ee-rec__nav">'
        +'    <button type="button" class="ee-rec__arrow" data-dir="prev" aria-label="'+esc(prevLabel)+'">'+prevSvg+'</button>'
        +'    <button type="button" class="ee-rec__arrow" data-dir="next" aria-label="'+esc(nextLabel)+'">'+nextSvg+'</button>'
        +'  </div>'
        +'</div>'
        +'<div class="ee-rec__track">'+cards+'</div>';
      track=root.querySelector('.ee-rec__track');
      var wrap=root.closest('.ee-rv-wrap');
      if(wrap){ wrap.style.display=''; } else { root.style.display=''; }
      initNav();
      initAdd();
    }

    function initNav(){
      var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
      var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
      function step(){ return Math.max(200, track.clientWidth*0.8); }
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
      function updateArrows(){
        if(!prev||!next) return;
        var m=track.scrollWidth-track.clientWidth-2;
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=m;
      }
      track.addEventListener('scroll',updateArrows,{passive:true});
      setTimeout(updateArrows,50);
      window.addEventListener('resize',updateArrows);
    }

    function initAdd(){
      root.addEventListener('click',function(e){
        var btn=e.target.closest('.ee-rec__add'); if(!btn) return;
        var id=btn.getAttribute('data-variant-id'); if(!id) return;
        btn.disabled=true;
        fetch(URL_ADD,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        }).then(function(r){ return r.json().catch(function(){return {};}); })
          .then(function(){
            btn.disabled=false;
            if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
              window.EE_CART_DRAWER.open();
            }else{
              document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
                var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
              });
            }
          }).catch(function(){ btn.disabled=false; });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-recommended"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sections=document.querySelectorAll('.ee-rec');
  sections.forEach(function(root){
    if(root.dataset.eeRecInit) return;
    root.dataset.eeRecInit='1';
    var track=root.querySelector('.ee-rec__track');
    var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';

    // --- nawigacja slidera ---
    var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
    var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
    function step(){ return Math.max(200, track.clientWidth*0.8); }
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    function updateArrows(){
      if(!prev||!next) return;
      var max=track.scrollWidth-track.clientWidth-2;
      prev.disabled=track.scrollLeft<=2;
      next.disabled=track.scrollLeft>=max;
    }
    track.addEventListener('scroll',updateArrows,{passive:true});
    setTimeout(updateArrows,50);
    window.addEventListener('resize',updateArrows);

    // --- dodawanie do koszyka: przez /cart/add.js, potem otwórz nasz drawer jeśli jest ---
    root.addEventListener('click',function(e){
      var btn=e.target.closest('.ee-rec__add'); if(!btn) return;
      var id=btn.getAttribute('data-variant-id'); if(!id) return;
      var label=btn.textContent;
      btn.disabled=true;
      fetch(URL_ADD,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:id,quantity:1}]})
      }).then(function(r){ return r.json().catch(function(){return {};}); })
        .then(function(){
          btn.disabled=false;
          // jeśli nasz drawer jest na stronie — otwórz go i odśwież
          if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
            window.EE_CART_DRAWER.open();
          }else{
            // brak drawera → zaktualizuj licznik w nagłówku (best-effort) i zostań na stronie
            document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
              var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
            });
          }
        }).catch(function(){ btn.disabled=false; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-similar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wraps=document.querySelectorAll('.ee-similar-wrap');
  wraps.forEach(function(wrap){
    if(wrap.dataset.eeSimInit) return;
    wrap.dataset.eeSimInit='1';

    var sectionId=wrap.getAttribute('data-section-id');
    var productId=wrap.getAttribute('data-product-id');
    var limit=wrap.getAttribute('data-limit')||'5';
    var intent=wrap.getAttribute('data-intent')||'related';
    if(!productId){ return; }

    // Product Recommendations API + Section Rendering API — dociagamy HTML sekcji
    // z wypelnionym recommendations.products (dziala tylko przez ten endpoint).
    var base=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var url=base+'recommendations/products?section_id='+encodeURIComponent(sectionId)
           +'&product_id='+encodeURIComponent(productId)
           +'&intent='+encodeURIComponent(intent)
           +'&limit='+encodeURIComponent(limit);

    fetch(url,{headers:{'Accept':'text/html'}})
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if(!html){ return; }
        // odpowiedz to pelny HTML sekcji; wyciagamy nasz wewnetrzny <section>
        var tmp=document.createElement('div');
        tmp.innerHTML=html;
        var inner=tmp.querySelector('.ee-similar');
        if(!inner){ return; } // brak rekomendacji → zostaw ukryte
        wrap.innerHTML='';
        wrap.appendChild(inner);
        wrap.style.display='';
        initNav(inner);
        initAdd(inner);
      })
      .catch(function(){}); // cichy fail — sekcja niekrytyczna

    function initNav(root){
      var track=root.querySelector('.ee-rec__track');
      if(!track) return;
      var prev=root.querySelector('.ee-rec__arrow[data-dir="prev"]');
      var next=root.querySelector('.ee-rec__arrow[data-dir="next"]');
      function step(){ return Math.max(200, track.clientWidth*0.8); }
      if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
      if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
      function upd(){
        if(!prev||!next) return;
        var m=track.scrollWidth-track.clientWidth-2;
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=m;
      }
      track.addEventListener('scroll',upd,{passive:true});
      setTimeout(upd,50);
      window.addEventListener('resize',upd);
    }

    function initAdd(root){
      var URL_ADD=(root.getAttribute('data-url-add')||'/cart/add')+'.js';
      root.addEventListener('click',function(e){
        var btn=e.target.closest('button.ee-rec__add'); if(!btn) return;
        var id=btn.getAttribute('data-variant-id'); if(!id) return;
        btn.disabled=true;
        fetch(URL_ADD,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:id,quantity:1}]})
        }).then(function(r){ return r.json().catch(function(){return {};}); })
          .then(function(){
            btn.disabled=false;
            if(window.EE_CART_DRAWER && typeof window.EE_CART_DRAWER.open==='function'){
              window.EE_CART_DRAWER.open();
            }else{
              document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(n){
                var cur=parseInt(n.textContent,10)||0; n.textContent=cur+1;
              });
            }
          }).catch(function(){ btn.disabled=false; });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-ee"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__eecInit) return;
  window.__eecInit = true;

  function root(){ return document.querySelector('.eec[data-section]'); }

  // ---- panel filtrów na telefonie ----
  function openFilters(r){ r.classList.add('is-filters-open'); document.documentElement.style.overflow='hidden'; }
  function closeFilters(r){ r.classList.remove('is-filters-open'); document.documentElement.style.overflow=''; }

  // ---- ładowanie wyników bez przeładowania strony (Section Rendering API) ----
  var busy = null;
  function load(url, push){
    var r = root(); if(!r) { window.location.href = url; return; }
    var sid = r.getAttribute('data-section');
    var keepOpen = r.classList.contains('is-filters-open');
    var openIdx = Array.prototype.map.call(r.querySelectorAll('.eec__f'), function(d){ return d.open; });
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    var fetchUrl = new URL(u.toString()); fetchUrl.searchParams.set('section_id', sid);
    if(busy) busy.abort();
    busy = ('AbortController' in window) ? new AbortController() : null;
    r.classList.add('is-loading');
    fetch(fetchUrl.toString(), busy ? {signal: busy.signal} : {})
      .then(function(res){ if(!res.ok) throw new Error(res.status); return res.text(); })
      .then(function(html){
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('.eec[data-section]');
        if(!fresh) throw new Error('no section');
        r.innerHTML = fresh.innerHTML;
        r.classList.remove('is-loading');
        // zachowaj otwarte/zamknięte grupy filtrów i otwarty panel na telefonie
        r.querySelectorAll('.eec__f').forEach(function(d, i){ if(openIdx[i] != null) d.open = openIdx[i] || d.open; });
        if(keepOpen) r.classList.add('is-filters-open'); else closeFilters(r);
        if(push !== false) history.pushState({eec:1}, '', u.pathname + u.search);
        if(!keepOpen){
          var top = r.getBoundingClientRect().top + window.scrollY - 20;
          if(window.scrollY > top) window.scrollTo({top: top, behavior: 'smooth'});
        }
      })
      .catch(function(e){ if(e && e.name === 'AbortError') return; window.location.href = u.toString(); });
  }

  function formUrl(form){
    var r = root();
    var base = (r && r.getAttribute('data-url')) || window.location.pathname;
    var params = new URLSearchParams();
    new FormData(form).forEach(function(val, key){ if(String(val).trim() !== '') params.append(key, val); });
    var sort = r && r.querySelector('[data-eec-sort]');
    if(sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    var q = params.toString();
    return base + (q ? '?' + q : '');
  }

  // filtry: checkbox od razu, cena po chwili
  var priceTimer = null;
  document.addEventListener('change', function(e){
    var form = e.target.closest && e.target.closest('[data-eec-form]');
    if(form){
      if(e.target.type === 'number'){ clearTimeout(priceTimer); priceTimer = setTimeout(function(){ load(formUrl(form)); }, 500); }
      else load(formUrl(form));
      return;
    }
    if(e.target.matches && e.target.matches('[data-eec-sort]')){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', e.target.value);
      u.searchParams.delete('page');
      load(u.pathname + u.search);
    }
  });
  document.addEventListener('submit', function(e){
    if(e.target.matches && e.target.matches('[data-eec-form]')){ e.preventDefault(); load(formUrl(e.target)); }
  });
  document.addEventListener('click', function(e){
    var t = e.target;
    var a = t.closest && t.closest('[data-eec-link]');
    if(a && !e.metaKey && !e.ctrlKey && !e.shiftKey){ e.preventDefault(); load(a.getAttribute('href')); return; }
    var r = root(); if(!r) return;
    if(t.closest && t.closest('[data-eec-open]')){ openFilters(r); return; }
    if(t.closest && t.closest('[data-eec-close]')){ closeFilters(r); return; }
  });
  document.addEventListener('keydown', function(e){
    var r = root();
    if(e.key === 'Escape' && r && r.classList.contains('is-filters-open')) closeFilters(r);
  });
  window.addEventListener('popstate', function(){ if(root()) load(window.location.pathname + window.location.search, false); });
})();

  } catch(e) { console.error(e); }
})();
})();
